import React, { useMemo } from 'react';
import styles from './style.module.scss';
import FilterDropdown, { DARK_THEME, FilterDropdownTheme } from 'components/search-bar/advanced-search/filter-dropdown';
import { searchFilterIds } from 'constants/test-constants';
import SqftIcon from 'components/icon/filters/sqft-icon';
import FilterDropdownRange from 'components/search-bar/advanced-search/filter-dropdown/number-range';
import formatPriceRange, { formatSqftRange } from 'utils/format-price';
import PriceIcon from 'components/icon/filters/price-icon';
//#region Types
export interface RangeFilterDropdownProps {
    min: number | null;
    max: number | null;
    theme?: FilterDropdownTheme;
    onValueChange: (min: number | null, max: number | null) => void;
    rangeType: 'sqft' | 'price';
    rental?: boolean;
}
//#endregion

const RangeFilterDropdown = ({ min, max, onValueChange, theme = DARK_THEME, rangeType, rental = false }: RangeFilterDropdownProps) => {
  const parseFilterLabel = useMemo(() => {
    if (rangeType === 'sqft') {
      return formatSqftRange(min, max);
    } else if (rangeType === 'price') {
      return formatPriceRange(min, max);
    }
  }, [min, max]);

  return (
    <FilterDropdown
      theme={theme}
      label={parseFilterLabel}
      testId={rangeType === 'sqft' ? searchFilterIds.sqftDropdownMap : searchFilterIds.priceRangeDropdownMap}
      contentClassName={styles['custom-panel-style']}
      icon={rangeType === 'sqft' ? <SqftIcon /> : <PriceIcon />}
      isDefaultValue={min === null && max === null}
    >
      <FilterDropdownRange
        min={min}
        max={max}
        isRental={rental}
        onValueChange={onValueChange}
        isCurrency={rangeType === 'price'}
      />
    </FilterDropdown>
  );
};

export default RangeFilterDropdown;